import { Flex, Headline, IconChevronRight, TextButton } from '@banhala/ui-kit';
import React from 'react';
import { ReviewSummarySkeleton } from './ReviewSummary.skeleton';
import { isNil, useNavigator } from 'shared/src/utils';
import { useGoodsReviewSummaryItem } from '../../hooks/useGoodsReviewSummaryItem';
import { ReviewSummaryPhotoReviewList } from './ReviewSummaryPhotoReviewList';
import { useLogClickReviewMore } from '../../hooks/useLogClickReviewMore';
import { useGoodsSno } from '../../../../../../hooks/useGoodsSno';
import { EvaluationList } from './EvaluationList';
import { AiFittingRoomSizeButton } from './AiFittingRoomSizeButton';

type ReviewSummaryProps = object;

const ReviewSummaryContent: React.FC<ReviewSummaryProps> = () => {
  const goodsSno = useGoodsSno();

  const summaryItem = useGoodsReviewSummaryItem();
  const { navigator } = useNavigator();

  const logClickReviewMore = useLogClickReviewMore();

  if (isNil(summaryItem)) {
    return null;
  }

  return (
    <Flex>
      <Headline
        headline={`${summaryItem.percent}%가 만족했어요`}
        size={'medium'}
        rightPanel={
          <TextButton
            size={'small'}
            color={'black'}
            onPress={() => {
              logClickReviewMore();
              navigator.moveToReviewList({ goodsSno });
            }}
            icon={<IconChevronRight />}
          >
            리뷰 전체보기
          </TextButton>
        }
        bottomCompact
      />
      <ReviewSummaryPhotoReviewList />
      <EvaluationList />
      {/* SizeAnalysis관련 로직이 추가되어야함*/}
      <AiFittingRoomSizeButton />
    </Flex>
  );
};
export const ReviewSummary: React.FC<ReviewSummaryProps> = props => {
  return (
    <React.Suspense fallback={<ReviewSummarySkeleton />}>
      <ReviewSummaryContent {...props} />
    </React.Suspense>
  );
};
